import StorageHelper from '@/utils/storageHelper';
import { store } from '@/store/store';
/**
 * Utility functions for managing window.insider_object operations
 */

/**
 * Sets the dailyQuizAnswer property in the user details
 * @param {boolean} value - The value to set for dailyQuizAnswer
 * @returns {Promise<boolean>} - Returns true if successfully set, false otherwise
 */
export const setDailyQuizAnswer = async value => {
  if (!isInsiderObjectAvailable()) {
    return false;
  }

  try {
    const userDetailsStorage = new StorageHelper({
      id: process.env.VUE_APP_STORAGE_CURRENT_USER_DETAIL,
    });

    const currentUserDetails = userDetailsStorage.get();
    if (!currentUserDetails) {
      console.warn('setDailyQuizAnswer: No user details found in storage');
      return false;
    }

    const updatedUserDetails = {
      ...currentUserDetails,
      dailyQuizAnswer: value,
    };

    // Update storage
    userDetailsStorage.set(updatedUserDetails);

    // Update store
    await store.dispatch('auth/setUserDetails', updatedUserDetails);

    // Update insider object
    setInsiderObject(updatedUserDetails);

    return true;
  } catch (error) {
    console.error('Error setting dailyQuizAnswer:', error);
    return false;
  }
};

/**
 * Gets the current dailyQuizAnswer value from the insider object
 * @returns {boolean|null} - Returns the current value or null if not available
 */
export const getDailyQuizAnswer = () => {
  if (isInsiderObjectAvailable()) {
    return window.insider_object.user.custom.dailyQuizAnswer;
  }
  return null;
};

/**
 * Checks if the insider object is available and properly initialized
 * @returns {boolean} - Returns true if insider object is available
 */
export const isInsiderObjectAvailable = () => {
  return !!(
    window.insider_object &&
    window.insider_object.user &&
    window.insider_object.user.custom
  );
};

/**
 * Sets up the insider object with user details
 * @param {Object} userDetails - User details object containing uuid, posChannel, businessPartners, etc.
 * @returns {boolean} - Returns true if successfully set, false otherwise
 */
export const setInsiderObject = userDetails => {
  if (userDetails) {
    try {
      window.insider_object = {
        user: {
          uuid: userDetails.uuid,
          customerCode: userDetails.customerCode,
          gdpr_optin: userDetails.gdprOptIn || true,
          custom: {
            pos_channel: userDetails.posChannel,
            business_partners: userDetails.businessPartners,
            daily_quiz_answer: userDetails.dailyQuizAnswer || false,
          },
        },
      };
      return true;
    } catch (error) {
      console.error('Error setting insider_object:', error);
      return false;
    }
  } else {
    console.warn('setInsiderObject called with null/undefined userDetails');
    return false;
  }
};
